var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"version":"1.1","id":"mdi-format-vertical-align-top","viewBox":"0 0 24 24","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M8,11H11V21H13V11H16L12,7L8,11M4,3V5H20V3H4Z"}}]})(props);
};
